export const formatPercentage = (value: number, { decimalPlace = '0' }) => {
  if (value === null || value === undefined) return '~'

  return `${(value * 100).toFixed(Number(decimalPlace))}%`
}
